import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const BoxArrowDownIcon = ({
  color,
  width = 16,
  height = 16,
  ...rest
}: {
  color?: string;
  width?: number;
  height?: number;
  [x: string]: unknown;
}) => {
  const { token } = useToken();
  return (
    <svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <path
        d="M13.9475 4.27625L12.9475 2.27625C12.9059 2.19318 12.842 2.12333 12.763 2.07454C12.684 2.02574 12.5929 1.99993 12.5 2H3.5C3.40711 1.99993 3.31604 2.02574 3.237 2.07454C3.15795 2.12333 3.09407 2.19318 3.0525 2.27625L2.0525 4.27625C2.01804 4.34581 2.00007 4.42237 2 4.5V13C2 13.2652 2.10536 13.5196 2.29289 13.7071C2.48043 13.8946 2.73478 14 3 14H13C13.2652 14 13.5196 13.8946 13.7071 13.7071C13.8946 13.5196 14 13.2652 14 13V4.5C13.9999 4.42237 13.982 4.34581 13.9475 4.27625ZM3.80875 3H12.1912L12.6912 4H3.30875L3.80875 3ZM13 13H3V5H13V13ZM10.3538 9.14625C10.4002 9.19269 10.4371 9.24783 10.4623 9.30853C10.4874 9.36923 10.5004 9.43429 10.5004 9.5C10.5004 9.56571 10.4874 9.63077 10.4623 9.69147C10.4371 9.75217 10.4002 9.80731 10.3538 9.85375L8.35375 11.8538C8.30731 11.9002 8.25217 11.9371 8.19147 11.9623C8.13077 11.9874 8.06571 12.0004 8 12.0004C7.93429 12.0004 7.86923 11.9874 7.80853 11.9623C7.74783 11.9371 7.69269 11.9002 7.64625 11.8538L5.64625 9.85375C5.55243 9.75993 5.49972 9.63268 5.49972 9.5C5.49972 9.36732 5.55243 9.24007 5.64625 9.14625C5.74007 9.05243 5.86732 8.99972 6 8.99972C6.13268 8.99972 6.25993 9.05243 6.35375 9.14625L7.5 10.2931V6.5C7.5 6.36739 7.55268 6.24021 7.64645 6.14645C7.74021 6.05268 7.86739 6 8 6C8.13261 6 8.25979 6.05268 8.35355 6.14645C8.44732 6.24021 8.5 6.36739 8.5 6.5V10.2931L9.64625 9.14625C9.69269 9.09976 9.74783 9.06288 9.80853 9.03772C9.86923 9.01256 9.93429 8.99961 10 8.99961C10.0657 8.99961 10.1308 9.01256 10.1915 9.03772C10.2522 9.06288 10.3073 9.09976 10.3538 9.14625Z"
        fill={color ?? token.colorIcon}
      />
    </svg>
  );
};

export default BoxArrowDownIcon;
